export default __webpack_public_path__ + "static/Everyelsewhere EP poster no text-96195016911a365c385b92af8c75e31d.jpg";